// Device detection utility
export const isMobileDevice = () => {
  // Check user agent for mobile devices
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Mobile device patterns
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  
  // Screen size check (additional check for tablets and small screens)
  const isSmallScreen = window.innerWidth <= 768;
  
  // Touch capability check
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  return mobileRegex.test(userAgent) || (isSmallScreen && isTouchDevice);
};

// Force mobile version (useful for testing)
export const forceMobileVersion = () => {
  return localStorage.getItem('forceMobile') === 'true';
};

// Force desktop version (useful for testing)
export const forceDesktopVersion = () => {
  return localStorage.getItem('forceDesktop') === 'true';
};

// Get the appropriate route based on device
export const getDeviceRoute = () => {
  if (forceDesktopVersion()) return '/desktop';
  if (forceMobileVersion()) return '/mobile';
  return isMobileDevice() ? '/mobile' : '/desktop';
};

// Helper functions for testing (can be called from browser console)
window.setMobileMode = () => {
  localStorage.setItem('forceMobile', 'true');
  localStorage.removeItem('forceDesktop');
  window.location.reload();
};

window.setDesktopMode = () => {
  localStorage.setItem('forceDesktop', 'true');
  localStorage.removeItem('forceMobile');
  window.location.reload();
};

window.setAutoMode = () => {
  localStorage.removeItem('forceMobile');
  localStorage.removeItem('forceDesktop');
  window.location.reload();
};
